import React, { Suspense } from "react";
import {
  Button,
  Dialog,
  Flex,
  InputField,
  SelectField,
  Typography,
  Snackbar,
  Gap,
} from "../../../ppui";
import { ContentHeading, ContentTable } from "../../style";
import useDepartmentService from "./use-department-service";
import { DEPARTMENT_INPUT_FIELDS } from "./department-constant";
import ErrorBoundary from "../../../utils/error-boundary";
import DepartmentList from "./department-list";

const OrganizationDepartment = () => {

const {esiInputs,
  setesiInputs,
  getInputFieldPropsFn,
  handleSubmitFn,
  createUpdateLoading,
  open,
  handleClickOpen,
  handleClose,
  resource,
  handleAddNewClickOpen,
  snackbarVisible,
  snackbarMessage,
  closeSnackbar,
  snackColor,
  }=useDepartmentService();

  return (
    <>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Department Management
          </Typography>

          <Button color="primary" variant="outlined" size="sm" onClick={handleAddNewClickOpen}>
            Add New
          </Button>
        </ContentHeading>

        
        
     
        <ContentTable>
        <ErrorBoundary
        fallback={<p>Something went wrong in fetching BankList...</p>}
      >
        <Suspense fallback={<p>Loading Department...</p>}>
          <DepartmentList
            resource={resource}
            handleAddNewClickOpen={handleAddNewClickOpen}
            setesiInputs={setesiInputs}
            handleClickOpen={handleClickOpen}
          />
        </Suspense>
      </ErrorBoundary>
          
        </ContentTable>

      {/* Modal */}
      <Dialog
        title={`${esiInputs?.department_id ? "Update" :"Create" } Department`}
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        loading={createUpdateLoading}
      >
        <Flex direction="column" width={"100%"} gap={"20"}>
          <InputField
            {...getInputFieldPropsFn(DEPARTMENT_INPUT_FIELDS.deptName.name)}

          />

          <SelectField
            {...getInputFieldPropsFn(DEPARTMENT_INPUT_FIELDS.status.name)}

          />
          <Gap height={40}/>
        </Flex>
      </Dialog>

      {/* Modal */}
      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
};

export default OrganizationDepartment;
